import { configureStore } from "@reduxjs/toolkit";

import AuthenticationReducer from "./Authentication/AuthenticationSlice";
import categoryReducer from "./Category/CategorySlice";
import restaurantReducer from "./Restaurant/RestaurantSlice";
import subcategoryReducer from "./Subcategory/SubcategorySlice";
import productReducer from "./Product/ProductSlice";
import addonsReducer from "./add_ons/AddOnsSlice";
import partnerReducer from "./delivery_partner/DeliveryPartnerSlice";

export const store = configureStore({
  reducer: {
    Authentication: AuthenticationReducer,
    category: categoryReducer,
    restaurant: restaurantReducer,
    subcategory: subcategoryReducer,
    product: productReducer,
    addons: addonsReducer,
    partner: partnerReducer,
  },
});
